//*** END: Types used inside charts  ***//
export var SupportedCommentResources;
(function (SupportedCommentResources) {
    SupportedCommentResources["EQUIPMENT"] = "EQUIPMENT";
    SupportedCommentResources["SENSOR"] = "SENSOR";
    SupportedCommentResources["SITE"] = "SITE";
    SupportedCommentResources["GATEWAY"] = "GATEWAY";
    SupportedCommentResources["EDGE"] = "EDGE";
    SupportedCommentResources["ACTUATOR"] = "ACTUATOR";
    SupportedCommentResources["VENSTARTHERMOSTAT"] = "VENSTARTHERMOSTAT";
    SupportedCommentResources["ENERGYBOXTHERMOSTAT"] = "ENERGYBOXTHERMOSTAT";
    SupportedCommentResources["THERMOSTAT"] = "THERMOSTAT";
})(SupportedCommentResources || (SupportedCommentResources = {}));
export var CommentType;
(function (CommentType) {
    CommentType["GENERAL"] = "GENERAL";
    CommentType["MAINTENANCE"] = "MAINTENANCE";
    CommentType["CORRECTIVE_ACTION"] = "CORRECTIVE_ACTION";
    CommentType["DAILY_CHECK"] = "DAILY_CHECK";
    CommentType["MONTHLY_CHECK"] = "MONTHLY_CHECK";
})(CommentType || (CommentType = {}));
export const CommentTypeLabel = {
    [CommentType.GENERAL]: 'General',
    [CommentType.MAINTENANCE]: 'Maintenance',
    [CommentType.CORRECTIVE_ACTION]: 'Corrective Action',
    [CommentType.DAILY_CHECK]: 'Daily Check',
    [CommentType.MONTHLY_CHECK]: 'Monthly Check',
};
export var ValueType;
(function (ValueType) {
    ValueType["BINARY"] = "BINARY";
    ValueType["TEMPERATURE"] = "TEMPERATURE";
    ValueType["HUMIDITY"] = "HUMIDITY";
    ValueType["ENERGY"] = "ENERGY";
    ValueType["ACTUATOR"] = "ACTUATOR";
    ValueType["VENSTARTHERMOSTAT"] = "VENSTARTHERMOSTAT";
    ValueType["ENERGYBOXTHERMOSTAT"] = "ENERGYBOXTHERMOSTAT";
    ValueType["THERMOSTAT"] = "THERMOSTAT";
    // NOTIFICATION = 'NOTIFICATION',
})(ValueType || (ValueType = {}));
export const ValueTypeLabel = {
    [ValueType.BINARY]: 'Door Access',
    [ValueType.TEMPERATURE]: 'Temperature',
    [ValueType.HUMIDITY]: 'Humidity',
    [ValueType.ENERGY]: 'Energy',
    [ValueType.ACTUATOR]: 'Relay',
    [ValueType.VENSTARTHERMOSTAT]: 'Venstar Thermostat',
    [ValueType.ENERGYBOXTHERMOSTAT]: 'Energybox Thermostat',
    [ValueType.THERMOSTAT]: 'Thermostat',
};
export const DisplayValueTypeLabel = {
    [ValueType.BINARY]: 'Door Access',
    [ValueType.TEMPERATURE]: 'Temperature',
    [ValueType.HUMIDITY]: 'Humidity',
    [ValueType.ENERGY]: 'Energy',
    [ValueType.ACTUATOR]: 'Relay',
    [ValueType.VENSTARTHERMOSTAT]: 'Thermostat',
    [ValueType.ENERGYBOXTHERMOSTAT]: 'Thermostat',
};
export const LabelToValueType = {
    'Door Access': ValueType.BINARY,
    Relay: ValueType.BINARY,
    Temperature: ValueType.TEMPERATURE,
    Thermostat: ValueType.TEMPERATURE,
    Humidity: ValueType.HUMIDITY,
    Energy: ValueType.ENERGY,
};
export const LabelToResourceType = {
    'Door Access': SupportedCommentResources.SENSOR,
    Relay: SupportedCommentResources.ACTUATOR,
    Temperature: SupportedCommentResources.SENSOR,
    VenstarThermostat: SupportedCommentResources.VENSTARTHERMOSTAT,
    EnergyboxThermostat: SupportedCommentResources.ENERGYBOXTHERMOSTAT,
    Thermostat: SupportedCommentResources.THERMOSTAT,
    Humidity: SupportedCommentResources.SENSOR,
    Energy: SupportedCommentResources.EQUIPMENT,
};
// to and from are ISO timestamps
// In the case of a fixed point set to and from to same value
export const newCommentFields = {
    to: '',
    from: '',
    value: '',
    valueType: null,
    commentType: CommentType.GENERAL,
    comment: '',
    resourceId: -1,
};
